export const COLORS = {
    PRIMARY_COLOR: "#FFFFFF",
    PRIMARY_BG: "#192681",
    SECONDARY_COLOR: "#5C5D61",
    SECONDARY_BG: "#FFFFFF",
    TRIOTERY_COLOR: "#0C0D13",
    TRIOTERY_BG: "#8F9092",
}